/**
 * Query params that Shopify automatically appends to the Admin Link extension URL.
 * These are available on every request to the /picker page.
 */
export enum ShopifyQueryParam {
  /** The merchant's myshopify.com domain, e.g. "my-store.myshopify.com" */
  Shop = 'shop',
  /** The GID numeric part of the resource being viewed, e.g. "1234567890" for a product */
  Id = 'id',
}
